const colours = {
  greyLight: '#c0c0c0',
  greyMedium: '#707070',
  blackSemi: '#212529',
  black: '#000000'
}

export {colours}